import * as React from 'react';
/**
 * @hidden
 */
export function HeaderSelectionCell(props) {
    var defaultRendering = [
        (React.createElement("input", { key: 0, checked: props.selectionValue, id: props.inputId, type: "checkbox", className: "k-checkbox", onChange: function (e) {
                return props.selectionChange({
                    field: props.field,
                    syntheticEvent: e
                });
            } })),
        (React.createElement("label", { key: 1, className: "k-checkbox-label", htmlFor: props.inputId }))
    ];
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
}
//# sourceMappingURL=HeaderSelectionCell.js.map